import { FinanceDateType } from '@trnsact/trnsact-shared-types';
import { FinanceFilters, FinanceFilterType } from './types';

export const initialFinanceFiltersValue: FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: 'cm',
  [FinanceFilterType.SALES_REP]: [],
  [FinanceFilterType.LOCATION]: [],
  [FinanceFilterType.PAYMENT_TYPE]: 'ALL' as const,
  [FinanceFilterType.DEAL_STATUS]: 'ALL',
  [FinanceFilterType.DATE_TYPE]: FinanceDateType.CreatedOn,
};
